import React from "react";
import { Box, Typography } from "@mui/material";
import CategoryBusinessCard from "../../../platform/pages/customer/categoryBusinessCard";

type Props = {
  businesses: any[];
};

export default function BookingBusinessCardList({ businesses }: Props): JSX.Element {
  if (!businesses.length) {
    return (
      <Typography color="text.secondary">
        No public booking businesses matched your search yet.
      </Typography>
    );
  }

  return (
    <>
      {businesses.map((business) => {
        const normalizedBusiness = business?.businessBasic
          ? {
              ...business.businessBasic,
              businessBookingTypes: business.businessBookingTypes,
              images: business.images,
            }
          : business;

        return (
        <Box key={business?.businessBasic?.id || business?.id} sx={{ mb: 1.5 }}>
          <CategoryBusinessCard
            business={normalizedBusiness}
            linkOverride={`/${normalizedBusiness?.url}`}
          />
        </Box>
        );
      })}
    </>
  );
}
